import { useEffect, useState } from 'react';
import { Justify } from '../../hooks/http/types';
import FullPageSpinner from '../common/FullPageSpinner';
import { Spinner } from "reactstrap";

export type SpinnerSize = 'normal' | 'large';

type LoadingSpinnerProps = {
    justify?: Justify;
    delayMs?: number;
    fullScreen?: boolean;
    text?: string;
};

const portalElement = document.getElementById('overlays');

const LoadingSpinner = ({
    delayMs,
    fullScreen,
    justify,
    text,
}: LoadingSpinnerProps) => {
    const [showSpinner, setShowSpinner] = useState<boolean>(false);

    useEffect(() => {
        const body = document.getElementsByTagName('body')[0];
        if (showSpinner && fullScreen) {
            body.style.paddingRight = '0';
            body.style.overflow = 'hidden';
        }

        return () => {
            body.style.overflow = 'auto';
        };
    }, [showSpinner]);

    setTimeout(() => {
        setShowSpinner(true);
    }, delayMs ?? 100);

    const fullScreenSpinner = <FullPageSpinner text={text ?? ''} />

    const cssClasses = `mt-3 mb-3 d-flex ${justify ? `justify-content-${justify}` : 'justify-content-center'}`;

    const spinner = fullScreen ? (
        fullScreenSpinner
    ) : (
        <div className={cssClasses}>
            <Spinner color='primary' type='grow' />
        </div>
    );

    return showSpinner ? spinner : null;
};

export default LoadingSpinner;